const { MICRO_FRONTEND_STARGATE_KEY } = require('../constants/index');
import { getAPI } from './ApiFunctions';
import { EPE_ACCESS_TOKEN } from '../constants/index';

/**
 * Function to get and cache micro-frontend stargate access token, uses caching .
 * @returns stargate access token value.
 */
export const getMicrofrontendStargate = async () => {
    const localStorageKey = `${EPE_ACCESS_TOKEN}-${MICRO_FRONTEND_STARGATE_KEY}`;
    let token = localStorage.getItem(localStorageKey);

    if (!token || JSON.parse(token).expiry < new Date().getTime()) {
        try {
            localStorage.removeItem(localStorageKey);
        } catch (err) {}
        const response = await getAPI(process.env.MICRO_FRONTEND_STARGATE_URL, null, null);
        response?.data?.forEach((result) => {
            if (result?.Name === MICRO_FRONTEND_STARGATE_KEY) {
                token = { value: result.Token };

                localStorage.setItem(
                    localStorageKey,
                    JSON.stringify({
                        value: result.Token,
                        expiry: new Date().getTime() + result.Expiration_in_seconds * 1000,
                    })
                );
            }
        });
    } else {
        token = JSON.parse(token);
    }
    return token.value;
};
